import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import apiClient, { API_BASE_URL } from '../utils/apiConfig';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import 'bootstrap/dist/css/bootstrap.min.css';

console.log(`🌐 [SendDocument] Usando API: ${API_BASE_URL}`);

// ⭐ LISTA DE DOCUMENTOS PARA SUBIDA MANUAL
const opcionesDocumentos = [
  { value: 'CONSENTIMIENTO INFORMADO - CIRUGIA', label: 'Consentimiento Informado - Cirugía' },
  { value: 'CONSENTIMIENTO INFORMADO PARA EL TRATAMIENTO DE DATOS BIOMETRICOS', label: 'Consentimiento Informado para el Tratamiento de Datos Biométricos' },
  { value: 'CUENTA DE COBRO', label: 'Cuenta de Cobro' },
  { value: 'FORMATO HUELLA', label: 'Formato Huella' },
  { value: 'OTRO', label: '📝 Otro (especificar)' }
];

const CORREOS_CORPORATIVOS_PERMITIDOS = [
  'soporte@colombianadetrasplantes.com',
  'aprendizti@colombianadetrasplantes.com',
  'jrivera@colombianadetrasplantes.com',
  'pbohorquez@colombianadetrasplantes.com',
  'jbarbosa@colombianadetrasplantes.com',
  'vgranada@colombianadetrasplantes.com'
];
const NUMEROS_CORPORATIVOS_PROHIBIDOS = [
  '3102068058','3102127563','3102131261','3102141055','3102150685',
  '3102176589','3102176649','3102191963','3102361183','3102510618',
  '3102541034','3102635971','3102636320','3102726526','3102740487',
  '3102740488','3102740544','3102740959','3102741268','3102741316',
  '3102741480','3102741484','3102741672','3102755111','3102756173',
  '3103002585','3103253677','3103254722','3103467915','3103467918',
  '3103467919','3103467947','3104829564','3105503634','3105503635',
  '3105503638','3105503648','3105655265','3105854859','3107990561',
  '3108032816','3108161289','3114621559','3115226590','3125086937',
  '3125221839','3125885035','3132011698','3132074035','3143070394',
  '3143842596','3144285616','3144342369','3144342414','3144342417',
  '3183659554','3208324712','3208324745','3208324751','3208324755',
  '3208373592','3208718652','3208718677','3208718759','3209334675',
  '3212032383','3212037877','3213298961','3214699077','3214902461',
  '3222175501','3222225062','3222792331','3223109438','3223272622',
  '3223447502','3223482427','3223508297','3226037672','3227024112',
  '3227670194','3228214806','3228823821','3228930725','3229489569',
  '3229489571','3232246487','3232246495','3232246499','3232286769',
  '3232286783','3232338706','3232738917','3232738918','3232738919',
  '3234962875','3102192061'
];

const esCelularCorporativoProhibido = (celular) => {
  if (!celular) return false;
  return NUMEROS_CORPORATIVOS_PROHIBIDOS.includes(celular.trim());
};

const esCorreoCorporativoNoPermitido = (correo) => {
  if (!correo) return false;
  const correoLower = correo.toLowerCase().trim();
  if (!correoLower.endsWith('@colombianadetrasplantes.com')) return false;
  return !CORREOS_CORPORATIVOS_PERMITIDOS.includes(correoLower);
};

const INITIAL_FORM_DATA = {
  cedula: '', nombres: '', correo: '', celular: '', eps: '',
  documento: null, nombreDocumento: '', nombreDocumentoOtro: '',
  sendMethods: [], tipo: 'medico'
};

const limpiarCaracteresEspeciales = (texto) =>
  texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-zA-Z0-9\s\-_().]/g, '');

const limpiarCedula = (texto) => texto.replace(/[^0-9]/g, '');

const tieneCaracteresEspeciales = (texto) => /[áéíóúüñÁÉÍÓÚÜÑ]/.test(texto);

function SendDocumentPage() {
  const navigate = useNavigate();

  const permisos = JSON.parse(localStorage.getItem('permisos') || '{}');
  const rol = localStorage.getItem('rol');
  const puedeMedico = rol === 'superadmin' || permisos.enviarDocumentosMedicos === true;
  const puedeAdmin = rol === 'superadmin' || permisos.enviarDocumentosAdministrativos === true;

  const [tipoSeleccionado, setTipoSeleccionado] = useState(() => {
    if (puedeMedico && !puedeAdmin) return 'medico';
    if (!puedeMedico && puedeAdmin) return 'administrativo';
    return null;
  });

  const [formData, setFormData] = useState(INITIAL_FORM_DATA);
  const [mensaje, setMensaje] = useState('');
  const [busquedaRealizada, setBusquedaRealizada] = useState(false);
  const [errors, setErrors] = useState({});
  const [sidebarAbierto, setSidebarAbierto] = useState(true);
  const [enviando, setEnviando] = useState(false);
  const [processingMessage, setProcessingMessage] = useState('');
  const [mensajeCaracteres, setMensajeCaracteres] = useState('');
  const [documentoSeleccionado, setDocumentoSeleccionado] = useState(null);
  const [paso, setPaso] = useState(1);
  const [modoDocumento, setModoDocumento] = useState('plantilla');
  const [plantillas, setPlantillas] = useState([]);
  const [plantillaSeleccionada, setPlantillaSeleccionada] = useState(null);
  const [previewData, setPreviewData] = useState(null);
  const [cargandoPreview, setCargandoPreview] = useState(false);

  // ⭐ Formulario dinámico
  const [showModalFormularioExtra, setShowModalFormularioExtra] = useState(false);
  const [camposFormulario, setCamposFormulario] = useState({});
  const [plantillaConFormulario, setPlantillaConFormulario] = useState(null);

  useEffect(() => {
    if (tipoSeleccionado === 'administrativo') navigate('/send-admin-document');
  }, [tipoSeleccionado, navigate]);

  useEffect(() => {
    const cargarPlantillas = async () => {
      try {
        const res = await apiClient.get('/api/plantillas', { params: { categoria: 'medico' } });
        setPlantillas(res.data.filter(p => p.activo !== false));
      } catch (error) {
        console.error('❌ Error cargando plantillas:', error);
      }
    };
    cargarPlantillas();
  }, []);

  useEffect(() => {
    if (plantillaSeleccionada && formData.cedula) {
      cargarPreviewAutomatico();
    } else {
      setPreviewData(null);
    }
  }, [plantillaSeleccionada]);

  const cargarPreviewAutomatico = async () => {
    if (!plantillaSeleccionada) return;
    setCargandoPreview(true);
    try {
      const response = await apiClient.post('/api/plantillas/preview-variables', {
        plantillaId: plantillaSeleccionada.value,
        datosPaciente: { nombres: formData.nombres, cedula: formData.cedula, eps: formData.eps, correo: formData.correo, celular: formData.celular }
      });
      if (response.data.success) setPreviewData(response.data);
    } catch (error) {
      console.error('Error cargando preview:', error);
    } finally {
      setCargandoPreview(false);
    }
  };

  const mostrarMensaje = (texto, tipo = 'info') => {
    const iconos = { success: '✅', error: '❌', warning: '⚠️' };
    setMensaje(`${iconos[tipo] || ''} ${texto}`);
  };

  const handleCedulaKeyDown = (e) => {
    if (e.key === 'Enter') { e.preventDefault(); handleBuscarPaciente(); }
  };

  const handleBuscarPaciente = async () => {
    if (!formData.cedula) { mostrarMensaje('Ingresa un número de documento válido.', 'warning'); return; }
    setBusquedaRealizada(false);
    setMensaje('🔍 Buscando paciente...');
    setPreviewData(null);
    try {
      const res = await apiClient.get(`/api/paciente/${formData.cedula}`, { timeout: 10000 });
      const { nombres, correo, celular, eps } = res.data;
      setFormData(prev => ({ ...prev, nombres, correo, celular, eps }));
      setBusquedaRealizada(true);
      setErrors({});
      mostrarMensaje('Paciente encontrado.', 'success');
    } catch (error) {
      if (error.response?.status === 404) {
        mostrarMensaje('Paciente no encontrado. Ingresa los datos manualmente.', 'warning');
      } else {
        mostrarMensaje('Error de conexión.', 'error');
      }
      setFormData(prev => ({ ...prev, nombres: '', correo: '', celular: '', sendMethods: [] }));
      setBusquedaRealizada(true);
      setErrors({});
    }
  };

  // ⭐ handlePlantillaChange actualizado para detectar formulario extra
  const handlePlantillaChange = async (opcion) => {
    setPlantillaSeleccionada(opcion);
    setErrors(prev => ({ ...prev, plantilla: '' }));
    setCamposFormulario({});
    setPlantillaConFormulario(null);

    if (opcion) {
      try {
        const res = await apiClient.get(`/api/plantillas/${opcion.value}`);
        const plantillaData = res.data;
        if (plantillaData.formularioExtra?.activo && plantillaData.formularioExtra?.campos?.length > 0) {
          setPlantillaConFormulario(plantillaData);
        }
      } catch (err) {
        console.warn('No se pudo verificar formulario extra:', err);
      }
    }
  };

  const handleDocumentoChange = (opcion) => {
    setDocumentoSeleccionado(opcion);
    if (opcion.value === 'OTRO') {
      setFormData(prev => ({ ...prev, nombreDocumento: '', nombreDocumentoOtro: '' }));
    } else {
      setFormData(prev => ({ ...prev, nombreDocumento: opcion.value, nombreDocumentoOtro: '' }));
    }
    setErrors(prev => ({ ...prev, nombreDocumento: '' }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file?.type === 'application/pdf') {
      setFormData(prev => ({ ...prev, documento: file }));
      setErrors(prev => ({ ...prev, documento: '' }));
    } else {
      setErrors(prev => ({ ...prev, documento: 'Solo se permiten archivos PDF.' }));
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'cedula') {
      setFormData(prev => ({ ...prev, [name]: limpiarCedula(value) }));
    } else if (name === 'nombres') {
      const nombreLimpio = limpiarCaracteresEspeciales(value);
      setFormData(prev => ({ ...prev, [name]: nombreLimpio }));
      if (tieneCaracteresEspeciales(value)) {
        setMensajeCaracteres('Se removieron las tildes automáticamente');
        setTimeout(() => setMensajeCaracteres(''), 3000);
      }
    } else if (name === 'correo') {
      setFormData(prev => ({ ...prev, [name]: value }));
      if (esCorreoCorporativoNoPermitido(value)) {
        setErrors(prev => ({ ...prev, correo: '🚫 No está permitido usar correos corporativos para pacientes.' }));
      } else {
        setErrors(prev => ({ ...prev, correo: '' }));
      }
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
    if (name !== 'correo') setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const handleMethodChange = (method) => {
    setFormData(prev => ({
      ...prev,
      sendMethods: prev.sendMethods.includes(method)
        ? prev.sendMethods.filter(m => m !== method)
        : [...prev.sendMethods, method]
    }));
    setErrors(prev => ({ ...prev, sendMethods: '' }));
  };

  const validarPaso = (pasoActual) => {
    const newErrors = {};
    if (pasoActual === 1) {
      if (!formData.cedula) newErrors.cedula = 'La cédula es obligatoria.';
      if (!formData.nombres) newErrors.nombres = 'El nombre es obligatorio.';
      if (!formData.correo && !formData.celular) newErrors.correo = 'Debe proporcionar correo o celular.';
      if (formData.correo && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.correo)) newErrors.correo = 'Correo no válido.';
      if (formData.correo && esCorreoCorporativoNoPermitido(formData.correo)) newErrors.correo = '🚫 No está permitido usar correos corporativos para pacientes.';
      if (formData.celular && !/^\d{10}$/.test(formData.celular)) newErrors.celular = 'Celular debe tener 10 dígitos.';
      if (formData.celular && esCelularCorporativoProhibido(formData.celular)) newErrors.celular = '🚫 No está permitido usar celulares corporativos para enviar documentos de pacientes.';
    }
    if (pasoActual === 2) {
      if (formData.sendMethods.length === 0) newErrors.sendMethods = 'Selecciona al menos un método.';
    }
    if (pasoActual === 3) {
      if (modoDocumento === 'plantilla') {
        if (!plantillaSeleccionada) newErrors.plantilla = 'Selecciona una plantilla.';
        // ⭐ Validar que el formulario extra esté completo si existe
        if (plantillaConFormulario) {
          const camposFaltantes = plantillaConFormulario.formularioExtra.campos
            .filter(c => c.requerido && !camposFormulario[c.variableWord]);
          if (camposFaltantes.length > 0) {
            newErrors.formularioExtra = `Completa el formulario antes de enviar (${camposFaltantes.length} campo(s) requerido(s))`;
          }
        }
      } else {
        if (!documentoSeleccionado) newErrors.nombreDocumento = 'Selecciona el tipo de documento.';
        else if (documentoSeleccionado.value === 'OTRO' && !formData.nombreDocumentoOtro) newErrors.nombreDocumento = 'Especifica el nombre del documento.';
        if (!formData.documento) newErrors.documento = 'Carga un archivo PDF.';
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const avanzarPaso = () => {
    if (validarPaso(paso)) { setPaso(paso + 1); setMensaje(''); }
  };

  const retrocederPaso = () => { setPaso(paso - 1); setMensaje(''); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validarPaso(3)) return;
    if (esCorreoCorporativoNoPermitido(formData.correo)) {
      mostrarMensaje('No está permitido usar correos corporativos para pacientes.', 'error'); return;
    }

    setEnviando(true);

    try {
      let archivoParaEnviar = null;
      let nombreFinal = '';

      if (modoDocumento === 'plantilla' && plantillaSeleccionada) {
        setProcessingMessage('📄 Generando documento...');

        // ⭐ Inicializar checkboxes no marcados como ☐ antes de enviar
        const datosExtraFinal = { ...camposFormulario };
        if (plantillaConFormulario) {
          plantillaConFormulario.formularioExtra.campos.forEach(c => {
            if (c.tipo === 'checkbox' && !datosExtraFinal[c.variableWord]) {
              datosExtraFinal[c.variableWord] = '☐';
            }
          });
        }

        const genResponse = await apiClient.post('/api/plantillas/generar-documento', {
          plantillaId: plantillaSeleccionada.value,
          datosPaciente: {
            nombres: formData.nombres, cedula: formData.cedula,
            eps: formData.eps, correo: formData.correo, celular: formData.celular
          },
          datosExtra: datosExtraFinal  // ⭐ Datos del formulario dinámico
        });

        if (!genResponse.data.success) throw new Error(genResponse.data.message || 'Error generando documento');

        const pdfResponse = await apiClient.get(genResponse.data.rutaRelativa, { responseType: 'blob' });
        const pdfBlob = new Blob([pdfResponse.data], { type: 'application/pdf' });
        archivoParaEnviar = new File([pdfBlob], genResponse.data.nombreArchivo, { type: 'application/pdf' });
        nombreFinal = plantillaSeleccionada.label;
      } else {
        archivoParaEnviar = formData.documento;
        nombreFinal = documentoSeleccionado.value === 'OTRO' ? formData.nombreDocumentoOtro : formData.nombreDocumento;
      }

      setProcessingMessage('📤 Enviando al paciente...');

      const formDataToSend = new FormData();
      formDataToSend.append('cedula', formData.cedula);
      formDataToSend.append('nombres', formData.nombres);
      formDataToSend.append('nombreDocumento', nombreFinal);
      formDataToSend.append('correo', formData.correo);
      formDataToSend.append('celular', formData.celular);
      formDataToSend.append('eps', formData.eps || '');
      formDataToSend.append('documento', archivoParaEnviar);
      if (modoDocumento === 'plantilla' && plantillaSeleccionada) {
        formDataToSend.append('plantillaId', plantillaSeleccionada.value);
      }
      formData.sendMethods.forEach(metodo => formDataToSend.append('sendMethods[]', metodo));
      formDataToSend.append('tipo', 'medico');

      await apiClient.post('/api/send-document', formDataToSend, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 120000
      });

      mostrarMensaje('Documento enviado exitosamente.', 'success');
      setProcessingMessage('✅ ¡Enviado! Redirigiendo...');
      setTimeout(() => navigate('/medical-documents'), 1500);

    } catch (error) {
      console.error('Error:', error);
      mostrarMensaje(error.response?.data?.message || 'Error al enviar.', 'error');
      setProcessingMessage('');
    } finally {
      setEnviando(false);
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? '#0d6efd' : '#ced4da',
      boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(13,110,253,.25)' : 'none',
      minHeight: '50px', fontSize: '1.1rem'
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#0d6efd' : state.isFocused ? '#e7f1ff' : 'white',
      color: state.isSelected ? 'white' : 'black', padding: '12px 15px'
    }),
    menu: (provided) => ({ ...provided, zIndex: 9999 })
  };

  const MiniPreview = () => {
    if (!previewData || !previewData.datos) return null;
    const { datos } = previewData;
    return (
      <div className="mt-3 p-3 bg-light border rounded" style={{ fontSize: '0.9rem' }}>
        <div className="d-flex align-items-center mb-2">
          <span className="badge bg-success me-2">✓</span>
          <strong>Variables que se usarán:</strong>
        </div>
        <div className="row">
          <div className="col-6">
            <small className="text-muted">Paciente:</small> {datos.paciente.nombre}<br/>
            <small className="text-muted">Cédula:</small> {datos.paciente.cedula}<br/>
            <small className="text-muted">EPS:</small> {datos.paciente.eps || <span className="text-warning">-</span>}
          </div>
          <div className="col-6">
            <small className="text-muted">Funcionario:</small> {datos.funcionario.nombre}<br/>
            <small className="text-muted">Fecha:</small> {datos.fecha}
          </div>
        </div>
      </div>
    );
  };

  // ═══════════════════════════════════════════════════════════════════════════
  // PANTALLA DE SELECCIÓN
  // ═══════════════════════════════════════════════════════════════════════════
  if (!tipoSeleccionado) {
    return (
      <div className="d-flex">
        <Sidebar onToggle={setSidebarAbierto} />
        <div className="flex-grow-1" style={{ marginLeft: sidebarAbierto ? '240px' : '80px', transition: 'margin-left 0.3s', padding: '20px 30px', minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
          <div className="container-fluid">
            <div className="mb-4">
              <h2 className="mb-1">📤 Enviar Documento para Firma</h2>
              <p className="text-muted mb-0">Selecciona el tipo de documento que deseas enviar</p>
            </div>
            <div className="row justify-content-center mt-5">
              <div className="col-md-5 mb-4">
                <div className="card shadow-sm h-100" style={{ cursor: 'pointer', transition: 'all 0.3s ease', border: '2px solid transparent' }}
                  onClick={() => setTipoSeleccionado('medico')}
                  onMouseOver={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.borderColor = '#0d6efd'; e.currentTarget.style.boxShadow = '0 8px 25px rgba(13,110,253,0.15)'; }}
                  onMouseOut={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.borderColor = 'transparent'; e.currentTarget.style.boxShadow = '0 .125rem .25rem rgba(0,0,0,.075)'; }}
                >
                  <div className="card-body text-center p-5">
                    <div style={{ fontSize: '4rem', marginBottom: '15px' }}>🏥</div>
                    <h3 className="card-title mb-3">Documento Médico</h3>
                    <p className="card-text text-muted" style={{ fontSize: '1.05rem' }}>Consentimientos informados, formatos médicos y documentos clínicos. Envío a un solo paciente con plantillas predefinidas.</p>
                    <div className="mt-4"><span className="badge bg-primary bg-opacity-10 text-primary px-3 py-2" style={{ fontSize: '0.9rem' }}>1 firmante · Plantillas · Firma rápida</span></div>
                  </div>
                </div>
              </div>
              <div className="col-md-5 mb-4">
                <div className="card shadow-sm h-100" style={{ cursor: 'pointer', transition: 'all 0.3s ease', border: '2px solid transparent' }}
                  onClick={() => navigate('/send-admin-document')}
                  onMouseOver={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.borderColor = '#198754'; e.currentTarget.style.boxShadow = '0 8px 25px rgba(25,135,84,0.15)'; }}
                  onMouseOut={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.borderColor = 'transparent'; e.currentTarget.style.boxShadow = '0 .125rem .25rem rgba(0,0,0,.075)'; }}
                >
                  <div className="card-body text-center p-5">
                    <div style={{ fontSize: '4rem', marginBottom: '15px' }}>📋</div>
                    <h3 className="card-title mb-3">Documento Administrativo</h3>
                    <p className="card-text text-muted" style={{ fontSize: '1.05rem' }}>Contratos, actas de comité, acuerdos y documentos con múltiples firmantes. Configura orden de firmas y ubica campos en el PDF.</p>
                    <div className="mt-4"><span className="badge bg-success bg-opacity-10 text-success px-3 py-2" style={{ fontSize: '0.9rem' }}>Múltiples firmantes · Orden de firma · Editor visual</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // ═══════════════════════════════════════════════════════════════════════════
  // FLUJO MÉDICO
  // ═══════════════════════════════════════════════════════════════════════════
  return (
    <div className="d-flex">
      <Sidebar onToggle={setSidebarAbierto} />
      <div className="flex-grow-1" style={{ marginLeft: sidebarAbierto ? '240px' : '80px', transition: 'margin-left 0.3s', padding: '20px 30px', minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
        <div className="container-fluid">

          {/* HEADER */}
          <div className="mb-4">
            <div className="d-flex align-items-center justify-content-between">
              <h2 className="mb-1">🏥 Enviar Documento Médico</h2>
              {puedeMedico && puedeAdmin && (
                <button type="button" className="btn btn-outline-secondary"
                  onClick={() => { setTipoSeleccionado(null); setPaso(1); setFormData(INITIAL_FORM_DATA); setBusquedaRealizada(false); setPlantillaSeleccionada(null); setDocumentoSeleccionado(null); setPreviewData(null); setMensaje(''); setCamposFormulario({}); setPlantillaConFormulario(null); }}>
                  ← Cambiar tipo de documento
                </button>
              )}
            </div>
          </div>

          {/* INDICADOR DE PASOS */}
          <div className="mb-4">
            <div className="d-flex justify-content-between align-items-center mb-2">
              {[1, 2, 3].map((num) => (
                <React.Fragment key={num}>
                  <div className={`rounded-circle d-flex align-items-center justify-content-center fw-bold ${paso >= num ? 'bg-primary text-white' : 'bg-secondary text-white'}`} style={{ width: '45px', height: '45px', fontSize: '1.1rem' }}>
                    {paso > num ? '✓' : num}
                  </div>
                  {num < 3 && <div className="flex-grow-1 mx-2" style={{ height: '4px', backgroundColor: paso > num ? '#0d6efd' : '#dee2e6' }} />}
                </React.Fragment>
              ))}
            </div>
            <div className="d-flex justify-content-between px-2">
              <small className={paso === 1 ? 'fw-bold text-primary' : 'text-muted'}>Paciente</small>
              <small className={paso === 2 ? 'fw-bold text-primary' : 'text-muted'}>Envío</small>
              <small className={paso === 3 ? 'fw-bold text-primary' : 'text-muted'}>Documento</small>
            </div>
          </div>

          {/* MENSAJES */}
          {mensaje && (
            <div className={`alert ${mensaje.includes('✅') ? 'alert-success' : mensaje.includes('❌') ? 'alert-danger' : 'alert-warning'} alert-dismissible`}>
              {mensaje}
              <button type="button" className="btn-close" onClick={() => setMensaje('')}></button>
            </div>
          )}
          {mensajeCaracteres && <div className="alert alert-info">{mensajeCaracteres}</div>}

          {/* FORMULARIO */}
          <form onSubmit={handleSubmit}>
            <div className="card shadow-sm">
              <div className="card-body p-4">

                {/* PASO 1: DATOS DEL PACIENTE */}
                {paso === 1 && (
                  <div>
                    <h4 className="mb-4">👤 Datos del Paciente</h4>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label fw-bold">Cédula:</label>
                        <div className="input-group input-group-lg">
                          <input type="text" name="cedula" value={formData.cedula} onChange={handleInputChange} onKeyDown={handleCedulaKeyDown} className={`form-control ${errors.cedula ? 'is-invalid' : ''}`} placeholder="Número de cédula" />
                          <button type="button" className="btn btn-primary" onClick={handleBuscarPaciente}>🔍 Buscar</button>
                        </div>
                        {errors.cedula && <div className="text-danger small mt-1">{errors.cedula}</div>}
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label fw-bold">Nombres:</label>
                        <input type="text" name="nombres" value={formData.nombres} onChange={handleInputChange} className={`form-control form-control-lg ${errors.nombres ? 'is-invalid' : ''}`} placeholder="Nombres y apellidos" disabled={!busquedaRealizada} />
                        {errors.nombres && <div className="text-danger small mt-1">{errors.nombres}</div>}
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label fw-bold">Correo:</label>
                        <input type="email" name="correo" value={formData.correo} onChange={handleInputChange} className={`form-control form-control-lg ${errors.correo ? 'is-invalid' : ''}`} placeholder="correo@ejemplo.com" disabled={!busquedaRealizada} />
                        {errors.correo && <div className="text-danger small mt-1">{errors.correo}</div>}
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label fw-bold">Celular:</label>
                        <input type="tel" name="celular" value={formData.celular} onChange={handleInputChange} className={`form-control form-control-lg ${errors.celular ? 'is-invalid' : ''}`} placeholder="3001234567" maxLength="10" disabled={!busquedaRealizada} />
                        {errors.celular && <div className="text-danger small mt-1">{errors.celular}</div>}
                      </div>
                    </div>
                    <div className="d-flex justify-content-end mt-4">
                      <button type="button" className="btn btn-primary btn-lg px-5" onClick={avanzarPaso}>Siguiente →</button>
                    </div>
                  </div>
                )}

                {/* PASO 2: MÉTODO DE ENVÍO */}
                {paso === 2 && (
                  <div>
                    <h4 className="mb-4">📧 ¿Cómo enviamos el documento?</h4>
                    <div className="row justify-content-center">
                      <div className="col-md-4 mb-3">
                        <div className={`p-4 border rounded-3 text-center ${formData.sendMethods.includes('correo') ? 'border-primary border-3 bg-primary bg-opacity-10' : 'border-secondary'}`}
                          style={{ cursor: formData.correo ? 'pointer' : 'not-allowed', opacity: formData.correo ? 1 : 0.5, transition: 'all 0.2s' }}
                          onClick={() => formData.correo && handleMethodChange('correo')}>
                          <div style={{ fontSize: '3rem' }}>📧</div>
                          <h5 className="mt-2">Correo Electrónico</h5>
                          {formData.correo && <small className="text-muted">{formData.correo}</small>}
                          {formData.sendMethods.includes('correo') && <div className="mt-2"><span className="badge bg-primary">✓ Seleccionado</span></div>}
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className={`p-4 border rounded-3 text-center ${formData.sendMethods.includes('sms') ? 'border-success border-3 bg-success bg-opacity-10' : 'border-secondary'}`}
                          style={{ cursor: formData.celular ? 'pointer' : 'not-allowed', opacity: formData.celular ? 1 : 0.5, transition: 'all 0.2s' }}
                          onClick={() => formData.celular && handleMethodChange('sms')}>
                          <div style={{ fontSize: '3rem' }}>📱</div>
                          <h5 className="mt-2">SMS</h5>
                          {formData.celular && <small className="text-muted">{formData.celular}</small>}
                          {formData.sendMethods.includes('sms') && <div className="mt-2"><span className="badge bg-success">✓ Seleccionado</span></div>}
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
        <div className={`p-4 border rounded-3 text-center ${formData.sendMethods.includes('whatsapp') ? 'border-success border-3 bg-success bg-opacity-10' : 'border-secondary'}`}
          style={{ cursor: formData.celular ? 'pointer' : 'not-allowed', opacity: formData.celular ? 1 : 0.5, transition: 'all 0.2s' }}
          onClick={() => formData.celular && handleMethodChange('whatsapp')}>
          <div style={{ fontSize: '3rem' }}><i className="bi bi-whatsapp" style={{ fontSize: '3rem', color: '#25D366' }}></i></div>
          <h5 className="mt-2">WhatsApp</h5>
          {formData.celular && <small className="text-muted">{formData.celular}</small>}
          {formData.sendMethods.includes('whatsapp') && <div className="mt-2"><span className="badge bg-success">✓ Seleccionado</span></div>}
        </div>
      </div>
                    </div>
                    {errors.sendMethods && <div className="alert alert-warning text-center mt-3">{errors.sendMethods}</div>}
                    <div className="d-flex justify-content-between mt-4">
                      <button type="button" className="btn btn-outline-secondary btn-lg" onClick={retrocederPaso}>← Atrás</button>
                      <button type="button" className="btn btn-primary btn-lg px-5" onClick={avanzarPaso}>Siguiente →</button>
                    </div>
                  </div>
                )}

                {/* PASO 3: DOCUMENTO */}
                {paso === 3 && (
                  <div>
                    <h4 className="mb-4">📄 Selecciona el Documento</h4>

                    <ul className="nav nav-pills nav-fill mb-4">
                      <li className="nav-item">
                        <button type="button" className={`nav-link ${modoDocumento === 'plantilla' ? 'active' : ''}`}
                          onClick={() => { setModoDocumento('plantilla'); setFormData(prev => ({ ...prev, documento: null })); setDocumentoSeleccionado(null); }}
                          style={{ fontSize: '1.1rem', padding: '15px' }}>
                          📋 Usar Plantilla
                        </button>
                      </li>
                      <li className="nav-item">
                        <button type="button" className={`nav-link ${modoDocumento === 'manual' ? 'active' : ''}`}
                          onClick={() => { setModoDocumento('manual'); setPlantillaSeleccionada(null); setPreviewData(null); setCamposFormulario({}); setPlantillaConFormulario(null); }}
                          style={{ fontSize: '1.1rem', padding: '15px' }}>
                          📤 Subir PDF
                        </button>
                      </li>
                    </ul>

                    {/* MODO: PLANTILLA */}
                    {modoDocumento === 'plantilla' && (
                      <div>
                        <label className="form-label fw-bold">Selecciona la plantilla:</label>
                        <Select
                          options={plantillas.map(p => ({ value: p._id, label: `${p.codigo} - ${p.nombre}` }))}
                          value={plantillaSeleccionada}
                          onChange={handlePlantillaChange}
                          placeholder="🔍 Buscar plantilla..."
                          noOptionsMessage={() => "No hay plantillas"}
                          styles={customStyles}
                          isSearchable={true}
                        />
                        {errors.plantilla && <div className="text-danger small mt-1">{errors.plantilla}</div>}

                        {cargandoPreview && (
                          <div className="text-center mt-3">
                            <div className="spinner-border spinner-border-sm text-primary me-2"></div>
                            Cargando datos...
                          </div>
                        )}

                        {plantillaSeleccionada && !cargandoPreview && <MiniPreview />}

                        {/* ⭐ BANNER FORMULARIO DINÁMICO */}
                        {plantillaConFormulario && (
                          <div className={`alert mt-3 d-flex align-items-center justify-content-between py-3 ${errors.formularioExtra ? 'alert-danger' : Object.keys(camposFormulario).length > 0 ? 'alert-success' : 'alert-warning'}`}>
                            <div>
                              <strong>📋 Esta plantilla requiere datos adicionales</strong>
                              <div className="small mt-1">
                                {errors.formularioExtra
                                  ? errors.formularioExtra
                                  : Object.keys(camposFormulario).length > 0
                                    ? `✅ Formulario completado (${Object.keys(camposFormulario).length} campo(s))`
                                    : 'Debes completar el formulario antes de enviar'}
                              </div>
                            </div>
                            <button
                              type="button"
                              className={`btn btn-sm ms-3 ${Object.keys(camposFormulario).length > 0 ? 'btn-success' : 'btn-warning'}`}
                              onClick={() => setShowModalFormularioExtra(true)}
                            >
                              {Object.keys(camposFormulario).length > 0 ? '✏️ Editar' : '📝 Completar'}
                            </button>
                          </div>
                        )}
                      </div>
                    )}

                    {/* MODO: SUBIR PDF */}
                    {modoDocumento === 'manual' && (
                      <div className="row">
                        <div className="col-12 mb-3">
                          <label className="form-label fw-bold">Archivo PDF:</label>
                          <input type="file" accept=".pdf" onChange={handleFileChange} className={`form-control form-control-lg ${errors.documento ? 'is-invalid' : ''}`} />
                          {errors.documento && <div className="text-danger small mt-1">{errors.documento}</div>}
                          {formData.documento && <small className="text-success mt-1 d-block">✅ {formData.documento.name}</small>}
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="form-label fw-bold">Tipo de documento:</label>
                          <Select options={opcionesDocumentos} value={documentoSeleccionado} onChange={handleDocumentoChange} placeholder="Seleccionar..." styles={customStyles} />
                          {errors.nombreDocumento && <div className="text-danger small mt-1">{errors.nombreDocumento}</div>}
                        </div>
                        {documentoSeleccionado?.value === 'OTRO' && (
                          <div className="col-md-6 mb-3">
                            <label className="form-label fw-bold">Nombre del documento:</label>
                            <input type="text" value={formData.nombreDocumentoOtro} onChange={(e) => setFormData(prev => ({ ...prev, nombreDocumentoOtro: limpiarCaracteresEspeciales(e.target.value).toUpperCase() }))} className="form-control form-control-lg" placeholder="Ej: INFORME MEDICO" />
                          </div>
                        )}
                      </div>
                    )}

                    {/* RESUMEN */}
                    {((modoDocumento === 'plantilla' && plantillaSeleccionada) ||
                      (modoDocumento === 'manual' && formData.documento && documentoSeleccionado)) && (
                      <div className="alert alert-info mt-4">
                        <h6 className="mb-2">📋 Resumen del envío:</h6>
                        <div className="row">
                          <div className="col-md-6">
                            <strong>Paciente:</strong> {formData.nombres}<br/>
                            <strong>Cédula:</strong> {formData.cedula}
                          </div>
                          <div className="col-md-6">
                            <strong>Documento:</strong> {modoDocumento === 'plantilla' ? plantillaSeleccionada?.label : (documentoSeleccionado?.value === 'OTRO' ? formData.nombreDocumentoOtro : documentoSeleccionado?.label)}<br/>
                            <strong>Envío por:</strong> {formData.sendMethods.map(m => m === 'correo' ? '📧 Correo' : '📱 SMS').join(' y ')}
                          </div>
                        </div>
                      </div>
                    )}

                    {/* BOTONES */}
                    <div className="d-flex justify-content-between mt-4">
                      <button type="button" className="btn btn-outline-secondary btn-lg" onClick={retrocederPaso}>← Atrás</button>
                      <button type="submit" className="btn btn-success btn-lg px-5"
                        disabled={enviando ||
                          (modoDocumento === 'plantilla' && !plantillaSeleccionada) ||
                          (modoDocumento === 'manual' && (!formData.documento || !documentoSeleccionado))
                        }>
                        {enviando ? <><span className="spinner-border spinner-border-sm me-2"></span>Enviando...</> : '📤 Enviar Documento'}
                      </button>
                    </div>
                  </div>
                )}

              </div>
            </div>
          </form>

          {/* ═══════════════════════════════════════════════════════════════ */}
          {/* ⭐ MODAL: FORMULARIO DINÁMICO DE LA PLANTILLA                  */}
          {/* ═══════════════════════════════════════════════════════════════ */}
          {showModalFormularioExtra && plantillaConFormulario && (
            <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.65)', zIndex: 9998, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 20 }}>
              <div style={{ background: 'white', borderRadius: 16, padding: 28, width: '100%', maxWidth: 520, boxShadow: '0 20px 60px rgba(0,0,0,0.3)', maxHeight: '90vh', overflowY: 'auto' }}>

                <h5 style={{ color: '#1a1e4b', marginBottom: 4 }}>📋 {plantillaConFormulario.nombre}</h5>
                <p style={{ color: '#6b7280', fontSize: 13, marginBottom: 20 }}>
                  Completa los siguientes campos para generar el documento correctamente.
                </p>

                {plantillaConFormulario.formularioExtra.campos.map((campo) => (
                  <div key={campo.id} style={{ marginBottom: 16 }}>

                    {/* CHECKBOX */}
                    {campo.tipo === 'checkbox' && (
                      <div
                        style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', borderRadius: 10, cursor: 'pointer', background: camposFormulario[campo.variableWord] === '☑' ? '#f0fdf4' : '#f9fafb', border: `2px solid ${camposFormulario[campo.variableWord] === '☑' ? '#22c55e' : '#e5e7eb'}`, transition: 'all 0.15s' }}
                        onClick={() => setCamposFormulario(prev => ({ ...prev, [campo.variableWord]: prev[campo.variableWord] === '☑' ? '☐' : '☑' }))}
                      >
                        <span style={{ fontSize: 22, flexShrink: 0 }}>{camposFormulario[campo.variableWord] === '☑' ? '☑' : '☐'}</span>
                        <span style={{ fontWeight: 500, color: '#374151', fontSize: 15 }}>{campo.etiqueta}</span>
                        {campo.requerido && <span style={{ color: '#ef4444', fontSize: 12, marginLeft: 'auto' }}>*requerido</span>}
                      </div>
                    )}

                    {/* FECHA */}
                    {campo.tipo === 'fecha' && (
                      <div>
                        <label style={{ fontSize: 14, fontWeight: 600, color: '#374151', marginBottom: 6, display: 'block' }}>
                          📅 {campo.etiqueta}
                          {campo.requerido && <span style={{ color: '#ef4444', marginLeft: 4 }}>*</span>}
                        </label>
                        <input
                          type="date"
                          onChange={(e) => {
                            const val = e.target.value;
                            if (val) {
                              const [y, m, d] = val.split('-');
                              setCamposFormulario(prev => ({ ...prev, [campo.variableWord]: `${d}/${m}/${y}` }));
                            } else {
                              setCamposFormulario(prev => ({ ...prev, [campo.variableWord]: '' }));
                            }
                          }}
                          style={{ width: '100%', padding: '10px 14px', borderRadius: 8, border: `2px solid ${camposFormulario[campo.variableWord] ? '#22c55e' : '#e5e7eb'}`, fontSize: 14 }}
                        />
                        {camposFormulario[campo.variableWord] && (
                          <small style={{ color: '#22c55e' }}>✅ {camposFormulario[campo.variableWord]}</small>
                        )}
                      </div>
                    )}

                    {/* TEXTO LIBRE */}
                    {campo.tipo === 'texto' && (
                      <div>
                        <label style={{ fontSize: 14, fontWeight: 600, color: '#374151', marginBottom: 6, display: 'block' }}>
                          ✏️ {campo.etiqueta}
                          {campo.requerido && <span style={{ color: '#ef4444', marginLeft: 4 }}>*</span>}
                        </label>
                        <input
                          type="text"
                          value={camposFormulario[campo.variableWord] || ''}
                          onChange={(e) => setCamposFormulario(prev => ({ ...prev, [campo.variableWord]: e.target.value }))}
                          placeholder={campo.placeholder || `Ingresa ${campo.etiqueta.toLowerCase()}...`}
                          style={{ width: '100%', padding: '10px 14px', borderRadius: 8, border: `2px solid ${camposFormulario[campo.variableWord] ? '#22c55e' : '#e5e7eb'}`, fontSize: 14 }}
                        />
                      </div>
                    )}
                  </div>
                ))}

                {/* BOTONES DEL MODAL */}
                <div style={{ display: 'flex', gap: 10, marginTop: 24 }}>
                  <button
                    type="button"
                    onClick={() => setShowModalFormularioExtra(false)}
                    style={{ flex: 1, padding: '12px', borderRadius: 50, border: '2px solid #e5e7eb', background: 'white', cursor: 'pointer', fontWeight: 600, fontSize: 14 }}
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      // Validar campos requeridos
                      const faltantes = plantillaConFormulario.formularioExtra.campos
                        .filter(c => c.requerido && !camposFormulario[c.variableWord])
                        .map(c => c.etiqueta);
                      if (faltantes.length > 0) {
                        alert(`Campos requeridos sin completar:\n• ${faltantes.join('\n• ')}`);
                        return;
                      }
                      // Inicializar checkboxes no marcados como ☐
                      const datosCompletos = { ...camposFormulario };
                      plantillaConFormulario.formularioExtra.campos.forEach(c => {
                        if (c.tipo === 'checkbox' && !datosCompletos[c.variableWord]) {
                          datosCompletos[c.variableWord] = '☐';
                        }
                      });
                      setCamposFormulario(datosCompletos);
                      setErrors(prev => ({ ...prev, formularioExtra: '' }));
                      setShowModalFormularioExtra(false);
                    }}
                    style={{ flex: 1, padding: '12px', borderRadius: 50, border: 'none', background: 'linear-gradient(135deg, #1a1e4b, #2d3494)', color: 'white', cursor: 'pointer', fontWeight: 700, fontSize: 14 }}
                  >
                    ✅ Confirmar
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* LOADING OVERLAY */}
          {enviando && (
            <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 }}>
              <div className="text-center bg-white p-5 rounded shadow-lg">
                <div className="spinner-border text-primary mb-3" style={{ width: '4rem', height: '4rem' }}></div>
                <h4>{processingMessage}</h4>
                <p className="text-muted mb-0">Por favor espera...</p>
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}

export default SendDocumentPage;